import PropTypes from 'prop-types';
import { CatHeading } from '@blocks-react/components/Heading';

const StickyCTATitleHeader = ({ leftLabel = '', rightLabel = '' }) => {
  return (
    <div className="d-flex justify-content-between w-100">
      <CatHeading variant="title-sm" className="text-capitalize">
        {leftLabel}
      </CatHeading>
      <CatHeading variant="title-sm">{rightLabel}</CatHeading>
    </div>
  );
};

StickyCTATitleHeader.propTypes = {
  leftLabel: PropTypes.string,
  rightLabel: PropTypes.string
};

export default StickyCTATitleHeader;
